const NotFound = () => (
    <div className="centered">
        <p style={{ fontSize: '18px' }}>Sorry. Page still in development!</p>
    </div>
);

export default NotFound;
